import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import LegalDialog from "./LegalDialog";

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalTab, setLegalTab] = useState("refund");

  const openLegal = (tab) => {
    setLegalTab(tab);
    setLegalOpen(true);
  };

  return (
    <footer className="border-t border-white/5 py-14 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <p className="font-serif text-2xl text-white">
            Kama <span className="gold-text">Loka Journeys</span>
          </p>
        </div>

        <div>
          <p className="font-sans text-[10px] uppercase tracking-overline text-[#D4AF37] mb-4">explore</p>
          <ul className="space-y-2 font-sans text-sm">
            <li><a href="#blueprint" className="text-slate-300 hover:text-[#D4AF37] transition-colors">Soul Blueprint</a></li>
            <li><a href="#sessions" className="text-slate-300 hover:text-[#D4AF37] transition-colors">Private sessions</a></li>
            <li><a href="#faq" className="text-slate-300 hover:text-[#D4AF37] transition-colors">FAQ</a></li>
          </ul>
        </div>

        <div>
          <p className="font-sans text-[10px] uppercase tracking-overline text-[#D4AF37] mb-4">legal</p>
          <ul className="space-y-2 font-sans text-sm">
            <li>
              <button
                data-testid="footer-link-refund"
                onClick={() => openLegal("refund")}
                className="text-slate-300 hover:text-[#D4AF37] transition-colors"
              >
                Refund policy
              </button>
            </li>
            <li>
              <button
                data-testid="footer-link-terms"
                onClick={() => openLegal("terms")}
                className="text-slate-300 hover:text-[#D4AF37] transition-colors"
              >
                Terms & conditions
              </button>
            </li>
            <li>
              <a
                href="mailto:kassie@kamalokajourneys.com.au"
                className="text-slate-300 hover:text-[#D4AF37] transition-colors"
                data-testid="footer-email"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-serif italic text-sm text-slate-400">
          "If you want to find the secrets of the universe, think in terms of energy, frequency and vibration."
        </p>
        <div className="flex items-center gap-4">
          <p className="font-sans text-xs tracking-overline text-slate-500 uppercase">
            Built by{" "}
            <a
              href="https://borntobealive.ai/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="borntobealive-link"
              className="gold-text hover:opacity-80 transition-opacity duration-200"
            >
              Borntobealive AI
            </a>
          </p>
          <span className="w-1 h-1 rounded-full bg-[#D4AF37]/30" aria-hidden="true" />
          <Link
            to="/admin"
            data-testid="footer-admin-gear"
            aria-label="Admin dashboard"
            title="Admin"
            className="group flex items-center justify-center w-7 h-7 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] hover:rotate-45 transition-all duration-300"
          >
            <Settings className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>

      <LegalDialog
        open={legalOpen}
        defaultTab={legalTab}
        onOpenChange={setLegalOpen}
      />
    </footer>
  );
}
